<template lang='pug'>
    .consultar-cnh-emitida.flex.justify-center.items-center.px-4.overflow-hidden(style='width:220px;height:360px;')

        div(v-if='waiting.consulta')
            ProgressSpinner.p-progress-spinner-md(strokeWidth='2')

        div(v-else-if='result')

            .p-grid.p-fluid

                .p-col-12(style='padding:0')
                    .text-center.my-4
                        p.text-xs.font-bold CONSULTA DE<br>SITUAÇÃO DE CNH
            
                .p-col-12(style='padding:0' v-if='result.error')
                    .px-4
                        p.text-xs.text-center.text-red-500.my-4.font-bold {{ result.message }}
                .p-col-12(style='padding:0' v-else)
                    p.text-xs.font-bold.text-green-600.mb-4.text-center CNH emitida em {{ result.dataEmissao_f }}
                    .text-gray-700
                        p.text-xs.font-bold Nome:
                        p.text-xs {{ result.nome }}
                        p.text-xs.font-bold CPF:
                        p.text-xs {{ model.cpf }}
                        p.text-xs.font-bold Local de entrega:
                        p.text-xs {{ result.localRecebimento }} - {{ result.cidadeRecebimento }}
                        p.text-xs.font-bold Nº lote:
                        p.text-xs {{ result.numeroLote }}

                .p-col-12
                    Button.p-button-secondary.p-button-text.cursor-pointer(icon='jam jam-chevron-left' label='Voltar' @click='model.reset(); captchaRefresh(); result = null')

        form(v-else @submit.prevent='handleSubmit')
            .p-grid.p-fluid.text-gray-700

                .p-col-12(style='padding:0')
                    .text-center
                        p.text-xs.font-bold CONSULTA DE<br>SITUAÇÃO DE CNH

                .p-col-12(style='padding:.2rem')
                    .field(:class="{'form-group--error': model.submitted && $v.model.cpf.$error }")
                        label.form-label.text-xs.font-semibold CPF:
                        InputMask(mask='999.999.999-99' placeholder='999.999.999-99' v-model='$v.model.cpf.$model')
                        .feedback--errors(v-if='model.submitted && $v.model.cpf.$error')
                            .form-message--error(v-if="!$v.model.cpf.required") Digite o <b>CPF</b>
                            .form-message--error(v-else-if="!$v.model.cpf.validateCpf") Digite um <b>CPF</b> válido

                .p-col-12(style='padding:.2rem')
                    .field(:class="{'form-group--error': model.submitted && $v.model.data_nascimento.$error }")
                        label.form-label.text-xs.font-semibold Data de nascimento:
                        InputMask(mask='99/99/9999' placeholder='dd/mm/aaaa' v-model='$v.model.data_nascimento.$model')
                        .feedback--errors(v-if='model.submitted && $v.model.data_nascimento.$error')
                            .form-message--error(v-if="!$v.model.data_nascimento.required") Digite a <b>data de nascimento</b>
                            .form-message--error(v-else-if="!$v.model.data_nascimento.dateValid") Digite uma <b>data</b> válida

                .p-col-12(v-if='captcha' style='padding:.2rem')
                    .field(:class="{'form-group--error': model.submitted && codigoInvalido }")
                        .relative
                            a.absolute.top-0.right-0.flex.justify-center.items-center.bg-white.rounded-bl-md.text-xs.w-4.h-4.cursor-pointer(@click='captchaRefresh()')
                                i.jam.jam-refresh
                            img(:src='captcha.image' class='w-full h-12')
                        InputText(maxlength='6' placeholder='Digite o código exibido acima' v-model='model.captcha' @input='codigoInvalido = false')
                        .feedback--errors(v-if='model.submitted && codigoInvalido')
                            .form-message--error <b>Código de verificação</b> inválido
                .p-col-12(style='padding:.25rem')
                    Button.cursor-pointer(type='submit' label='Consultar')
</template>

<style lang="scss">
    .consultar-cnh-emitida {
        .p-inputtext, .p-button-label {
            font-size: .75rem;
        }
    }
</style>

<script>
    import InputMask from 'primevue/inputmask'
    import InputText from 'primevue/inputtext'
    import Button from 'primevue/button'
    import ProgressSpinner from 'primevue/progressspinner'
    
    import { required } from 'vuelidate/lib/validators'
    import { validateCpf } from './../../../utils'
    import middleware from './middleware'
    import moment from 'moment'

    export default {
        components: { InputMask, InputText, Button, ProgressSpinner },
        created () { this.captchaRefresh() },
        data () {

            const model = {
                cpf: null,
                data_nascimento: null,
                captcha: null,
                submitted: false,
                reset () {
                    this.captcha = null
                    this.submitted = false
                }
            }

            return {
                model,
                waiting: { consulta: false },
                captcha: null,
                codigoInvalido: false,
                result: null
            }
        },
        validations () {
            let v = {
                model: {
                    cpf: { required, validateCpf },
                    data_nascimento: {
                        required,
                        dateValid: val => moment(val, 'DD/MM/YYYY').isValid()
                    }
                }
            }
            return v
        },
        methods: {
            captchaRefresh () {  this.captcha = require("nodejs-captcha")() },
            handleSubmit () {
                this.model.submitted = true
                this.$v.$touch(); if (this.$v.$invalid) return 0
                if (this.model.captcha !== this.captcha.value) {
                    this.codigoInvalido = true
                    return 0
                }
                
                let dataSend = Object.assign({}, this.model)
                dataSend.data_nascimento = moment(dataSend.data_nascimento, 'DD/MM/YYYY').format('YYYYMMDD')
                dataSend.cpf = dataSend.cpf.match(/\d+/g).join('')
                delete dataSend.submitted
                delete dataSend.reset

                this.waiting.consulta = true

                middleware.consultarCnhEmitida(dataSend.cpf, dataSend.data_nascimento).then(response => {
                    this.waiting.consulta = false
                    this.result = response.data
                    if (! this.result.error) {
                        this.result.dataEmissao_f = moment(this.result.dataEmissao).format('DD/MM/YYYY')
                    }
                })
            }
        }
    }
</script>